import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { merge, $ } from "glamor";
//import Color from 'color';
import theme from "styles/theme";
import classNames from "classnames";

const BACKGROUND_COLOR = theme.palette.darkerGrey; //Color('#262626').mix( Color(theme.palette.primary1Color), .95).rgbString();
const WIDTH = 280;

class Layer extends PureComponent {
    static propTypes = {
        depth: PropTypes.number.isRequired,
        iconsOnly: PropTypes.bool,
        type: PropTypes.oneOf(["menu", "pane", "root"]),
    };

    static defaultProps = {
        type: "menu",
        iconsOnly: false,
    };

    styles = merge(
        {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            top: "0px",
            height: "100%",
            width: `${WIDTH}px`,
            overflowY: "none",
            transition: "all .15s ease-in-out",
            backgroundColor: BACKGROUND_COLOR,
            zIndex: 1001 + this.props.depth,
            left: `${WIDTH * this.props.depth}px`,
        },
        $(".menu", {
            position: "absolute",
            top: "0px",
            left: "100%",
            height: "auto",
            opacity: 0,
            transform: "translate(0, 24px)",
        }),
        $(".appeared.menu", {
            opacity: 1,
            transform: "translate(0, 0)",
        }),
        $(".iconsOnly", {
            width: "60px",
        }),
        $(
            ".isMobile &",
            merge(
                $(".menu", {
                    position: "static",
                    top: "0px",
                    left: "0px",
                    paddingLeft: "54px",
                    height: "auto",
                    opacity: 1,
                    transform: "none",
                    width: "100%",
                })
            )
        )
    );

    constructor(props) {
        super(props);
        this.state = {
            appeared: false,
            style: undefined,
        };
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    componentDidMount() {
        const elBoundings = this._ref.getBoundingClientRect();
        const offsetFromBottom = window.innerHeight - elBoundings.top - elBoundings.height;
        const isVerticalOverflowed = window.innerHeight < elBoundings.height;
        if (offsetFromBottom < 0) {
            this.setState({
                style: {
                    top: `${offsetFromBottom}px`,
                },
            });
        }
        if (isVerticalOverflowed) {
            this.setState({
                style: {
                    overflowY: "auto",
                    height: `${window.innerHeight / 2}px`,
                },
            });
        }
    }

    componentDidAppear() {
        process.nextTick(() => {
            if (!this.unmounted) {
                this.setState({ appeared: true });
            }
        });
    }

    componentDidEnter() {
        process.nextTick(() => {
            if (!this.unmounted) {
                this.setState({ appeared: true });
            }
        });
    }

    render() {
        const { depth, type, iconsOnly, children } = this.props;
        const { appeared, style } = this.state;
        return (
            <div
                {...this.styles}
                className={classNames(`depth${depth}`, type, {
                    iconsOnly,
                    appeared,
                })}
                ref={(ref) => (this._ref = ref)}
                style={style}
            >
                {children}
            </div>
        );
    }
}

export default Layer;
